<template>
  <div>
    <el-upload
        ref='upload'
        :class="{hide:hideUpload}"
        :disabled='imgDisabled'
        action=""
        accept="image/jpeg,image/gif,image/png,image/bmp"
        list-type="picture-card"
        :file-list="fileList"
        :http-request="handleRequest"
        :on-remove="handleRemove"
        :before-upload="beforeAvatarUpload"
        :on-error="handleError"
        :on-preview="handlePictureCardPreview">
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog
        width="30%"
        title="图片详情"
        :visible.sync="dialogVisible"
        append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'upload',
  data () {
    return {
      dialogVisible: false,
      dialogImageUrl: false,
      hideUpload: false,
      loser: true
    }
  },
  props: {
    limitCount: {
      type: Number,
      default: 1
    },
    imgDisabled: {
      type: Boolean,
      default: false
    },
    fileList: {
      type: Array,
      default: null
    }
  },
  created () {
    this.hideUpload = this.fileList.length >= this.limitCount
  },
  watch: {
    'fileList': function (fileList) {
      this.hideUpload = this.fileList.length >= this.limitCount
    }
  },
  methods: {
    handleRequest(param) {
      let fileObj = param.file;
      this.hideUpload=true
      this.$emit('input', fileObj)
    },
    handleError (file) {
      this.$notify.error({
        title: '错误警告',
        message: '图片上传失败了请重新上传',
        type: 'warning'
      })
    },
    beforeAvatarUpload (file,fileList) {
      this.loser = true
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 512 / 512 < 2
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!')
        this.loser = false
        return false
      } else if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 500kb!')
        this.loser = false
        return false
      } else {
        return isJPG && isLt2M
      }
    },
    handleRemove (file, fileList) { // 删除图片
      this.hideUpload = this.fileList >= this.limitCount
    },
    handlePictureCardPreview (file) { // 放大
      if (file.response) {
        this.dialogImageUrl = file.response.message
      } else {
        this.dialogImageUrl = file.url
      }
      this.dialogVisible = true
    },
    // elementUI mixins - emitter 中拷贝的 |||
    dispatch (componentName, eventName, params) {
      let parent = this.$parent || this.$root
      let name = parent.$options.componentName
      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent
        if (parent) {
          name = parent.$options.componentName
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params))
      }
    }
  }
}
</script>
<style>
.el-notification__group{
  margin-right: auto;
}
.hide .el-upload--picture-card {
  display: none;
}
</style>>
